module.exports = __webpack_public_path__ + "static/media/shape.0c9a551f.png";